angular.module('bmsApp.crm.salespipeline')
	.controller('SalesPipelineIndexCtrl', function ($state,
													$scope,
													$timeout,
													$filter,
													$q,
													$cookies,
													ngTableParams,
													SalesPipelineSvc,
                                                    SalesPipelineStatusesSvc,
													$localStorage) {

		var defaultTableParams = function () {
			return {
				page: 1, // show first page
				count: $scope.config.table.params.count, // count per page
				sorting: {
					id: 'desc' // initial sorting
				},
				filter: self.filter
			};
		};

		var initialParams = function () {
			if (angular.isDefined($localStorage.pipelineJobIndexParams)) {
				self.filter = $localStorage.pipelineJobIndexParams.filter;
				return angular.extend({}, defaultTableParams(), $localStorage.pipelineJobIndexParams);
			}
			else {
				return angular.extend({}, defaultTableParams());
			}
		};

		function init() {
			var params = initialParams();
			console.log(params);
			self.tableParams = new ngTableParams(params, {
				total: 0, // length of data
				counts: $scope.config.table.settings.counts, // available page counts
				getData: function ($defer, params) {
					self.rzsliderOptions.disabled = true;
					$localStorage.pipelineJobIndexParams = params.$params;
					SalesPipelineSvc.index(params.$params)
						.then(function (response) {
							self.loading = false;
							self.salesPipelines = response.data.sales_pipelines;
                            params.total(response.data.sales_pipelines_total);
                            self.totalCount = response.data.sales_pipelines_total;
							$defer.resolve(self.salesPipelines);
                            self.rzsliderOptions.disabled = false;
                            $scope.$emit('SalesPipelineOverview', {
								"totalResults": self.salesPipelines.length,
								"pan": defaultTableParams(),
								"filter": self.filter,
								"overview": response.data.sales_pipeline_overview
                        	});
							// Check if we've exceeded our page size, if we have, go back
							if (response.data.sales_pipelines_total > 0 && !response.data.sales_pipelines.length) {
								let newParams = angular.copy($scope.tableParams.$params);
								newParams.page--;
								angular.extend($scope.tableParams.$params, newParams);
							}
                        });
				}
			});

            SalesPipelineSvc.index(params.$params)
                .then(function (response) {
                    self.loading = false;
                    if(response.data.sales_pipelines_total > 0){
                        self.noPipelines = false;
                    }
                });

			SalesPipelineStatusesSvc.index(null).then(function(response){
				self.options = response.data.sales_pipelines_statuses;
			});
		}

		function sliderOnChange() {
			self.tableParams.reload();
		}

		function gotoEdit(pipeline) {
			console.log(pipeline);
		}

		var self = $scope.SalesPipelineIndexCtrl = {
			methods: {
				init: init,
				sliderOnChange: sliderOnChange,
				gotoEdit: gotoEdit
			},
			loading: true,
			salesPipelines: [],
			overview: [],
			options: [],
			rzsliderOptions: {
                disabled: false,
				floor: 0,
				ceil: 100,
				step: 5,
            },
			totalCount: 0,
			noPipelines: true,
			filter: {
                sales_pipeline_status_type: null,
                probability: {
                    max: 100,
                    min: 0,
                    translate: function (value, sliderId, label) {
                        return value + '%';
                    }
                },
			},
			changed: false,
			tableParams: []
		};

	});